/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Apa_GInputs */

const en_mk_tut_apa_g = /** @type {(inputs: Mk_Tut_Apa_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before you press anything, it helps to know the shape of the product. KerjaBareng is one workspace where work is recorded, discussed, and partly done by AI agents that you control.`)
};

const id_mk_tut_apa_g = /** @type {(inputs: Mk_Tut_Apa_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebelum menekan apa pun, ada baiknya Anda tahu bentuk produknya. KerjaBareng adalah satu ruang kerja tempat pekerjaan dicatat, dibicarakan, dan sebagian dikerjakan oleh agen AI yang Anda kendalikan.`)
};

/**
* | output |
* | --- |
* | "Before you press anything, it helps to know the shape of the product. KerjaBareng is one workspace where work is recorded, discussed, and partly done by AI a..." |
*
* @param {Mk_Tut_Apa_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_apa_g = /** @type {((inputs?: Mk_Tut_Apa_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Apa_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_apa_g(inputs)
	return en_mk_tut_apa_g(inputs)
});